// noinspection JSUnusedGlobalSymbols

export class Local {
    public static APP_ID = "local/appId";
    public static APP_NAME = "local/appName";
    public static DATASERVER_URL = "local/dataserverURL";
    public static LOGIN_TOKEN = "local/loginToken";
    public static DEMO = "local/demo";
}
